export const colors = {
    "Run": "#1d988c",
    "Grow": "#325d9e",
    "Transform": "#212121",
    "Progressive Culture": "#1d988c",
    "Collaborative Partnerships": "#325d9e",
    "Fiscal Stewardship": "#212121",
    "Organization Excellence": "#b9b9b9",
} as any;